<p-card [style]="{ width: '100%' }">
  <ng-template pTemplate="header">
    <div class="card-header p-card-title">
      <div class="title">
        <i
          class="pi pi-file-pdf"
          style="font-size: 1.5rem"
        ></i>
        <ng-container i18n="@@documents_space_list_title">Espaces de documents</ng-container>
      </div>
      <div class="custom-upload-btn">
        <button
          class="p-button-outlined"
          pButton
          (click)="openDocumentsSpaceSetting()"
          type="button"
          label="Créer"
          i18n-label="@@documents_space_list_create_button"
          icon="fa fa-plus-circle"
        ></button>
      </div>
    </div>
  </ng-template>
  <p-dialog
    [style]="{ width: '60%' }"
    header="Avertissement sur les limitations"
    [modal]="true"
    [(visible)]="showDisclaimer"
    [focusOnShow]="true"
    [closable]="false"
    autoZIndex="true"
  >
    <span
      >La fonctionnalité 'Espaces de documents' est en phase test et comporte certaines limitations qui sont en cours
      d'amélioration.</span
    >
    <ul>
      <li>
        <span class="font-bold">Hallucinations possibles</span> : Le modèle peut générer des informations incorrectes ou
        inexistantes dans le corpus de document. Vérifiez toujours les résultats.
      </li>
      <li>
        <span class="font-bold">Exhaustivité limitée</span> : Les réponses peuvent omettre certaines informations
        importantes.
      </li>
      <li>
        <span class="font-bold">Résumés partiels</span> : L'espace de document n’est pas optimisé pour restituer toutes
        les informations dans un résumé complet.
      </li>
    </ul>
    <div class="flex align-items-center justify-content-center mt-4">
      <p-checkbox
        class="m-2"
        #dontShowAgainCheckbox
        binary="true"
        label="Ne plus afficher ce message"
      />
    </div>
    <div class="flex align-items-center justify-content-center">
      <p-button
        (click)="onCloseDisclaimer(dontShowAgainCheckbox.checked())"
        label="J'ai lu et accepte les limitations"
      />
    </div>
  </p-dialog>

  <p-table
    [value]="documentsSpaces"
    [lazy]="true"
    (onLazyLoad)="loadItems($event.first!)"
    dataKey="id"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
    [showCurrentPageReport]="true"
    [(first)]="actualPage"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 35%">
          <ng-container i18n="@@documents_space_list_name_column">Nom de l'espace partagé</ng-container>
        </th>
        <th style="width: 20%">
          <ng-container i18n="@@documents_space_list_date_column">Date de création</ng-container>
        </th>
        <th style="width: 20%">
          <ng-container i18n="@@documents_space_list_owner_column">Propriétaire</ng-container>
        </th>
        <th style="width: 10%">
          <ng-container i18n="@@document_list_status_column">Status</ng-container>
        </th>
        <th style="width: 10%"></th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-documentsSpace
      [ngAs]="DocumentsSpace"
    >
      @if (pageLoading) {
        <tr>
          <td colspan="5">
            <div class="flex align-items-center justify-content-center mt-4">
              <p-progressSpinner
                styleClass="w-3rem h-3rem"
                strokeWidth="5"
              />
            </div>
          </td>
        </tr>
      } @else {
        <tr
          class="clickable-row"
          [routerLink]="'/documents-spaces/' + documentsSpace.id"
        >
          <td>
            {{ documentsSpace.name }}
          </td>
          <td>
            {{ documentsSpace.createdAt | date: "dd MMMM yyyy, HH'h'mm" : "CEST" }}
          </td>
          <td>
            {{ documentsSpace.ownerName }}
          </td>
          <td>
            @if (documentsSpace.status !== "DONE" && documentsSpace.status !== "ERROR") {
              <p-progressSpinner
                styleClass="w-1rem h-1rem mr-2"
                strokeWidth="8"
                animationDuration=".5s"
              />
            }
            <span [class]="mediaStatusData[documentsSpace.status].cssClass">{{
              mediaStatusData[documentsSpace.status].text
            }}</span>
          </td>

          <td>
            <div class="flex gap-3">
              @if (documentsSpace.ownerName === accountService.getAccountName()) {
                <button
                  class="p-button-outlined p-button-danger p-button-sm"
                  pButton
                  (click)="$event.stopImmediatePropagation(); deleteItem(documentsSpace.id)"
                  type="button"
                  label="Supprimer"
                  i18n-label="@@document_list_delete_item_label"
                  icon="pi pi-trash"
                ></button>
              }
            </div>
          </td>
        </tr>
      }
    </ng-template>
  </p-table>
</p-card>
